import { IState } from '../store';
import { pathOr } from 'ramda';

export const getDynamicCalltrackingSiteBlockId = (state: IState) => {
  return pathOr(null, ['offerData', 'newbuildingDynamicCalltracking', 'siteBlockId'], state);
};
